import React from 'react';
import { t } from '../../../utils/i18n';
import {
  avgEngagementPerUser,
  formatEngagementDuration,
  formatPercent,
  getLatestGaRow,
  sumGaField,
} from '../../../utils/gaDashboard';
import DashboardKpi from '../components/DashboardKpi';

export default function GaKpiCards({ rows, isLoading }) {
  if (isLoading) {
    return (
      <div className="space-y-3">
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 xl:grid-cols-6">
          {Array.from({ length: 6 }).map((_, i) => (
            <div
              key={i}
              className="h-[88px] animate-pulse rounded-lg border border-dark-border bg-dark-card"
            />
          ))}
        </div>
        <div className="grid grid-cols-3 gap-2 xl:grid-cols-6">
          {Array.from({ length: 9 }).map((_, i) => (
            <div
              key={i}
              className="h-14 animate-pulse rounded-lg border border-dark-border bg-dark-card"
            />
          ))}
        </div>
      </div>
    );
  }

  const latest = getLatestGaRow(rows);

  const primary = [
    { label: t('dashboard.ga.kpi.dau'), value: latest?.dau ?? '—', accent: true },
    { label: t('dashboard.ga.kpi.wau'), value: latest?.wau ?? '—', accent: true },
    { label: t('dashboard.ga.kpi.mau'), value: latest?.mau ?? '—', accent: true },
    { label: t('dashboard.ga.kpi.newUsers'), value: sumGaField(rows, 'newUsers') || '—' },
    { label: t('dashboard.ga.kpi.sessions'), value: sumGaField(rows, 'sessions') || '—' },
    {
      label: t('dashboard.ga.kpi.engagementRate'),
      value: latest ? formatPercent(latest.engagementRate) : '—',
      accent: true,
    },
  ];

  const secondary = [
    {
      label: t('dashboard.ga.kpi.engagedSessions'),
      value: sumGaField(rows, 'engagedSessions') || '—',
    },
    { label: t('dashboard.ga.kpi.eventCount'), value: sumGaField(rows, 'eventCount') || '—' },
    { label: t('dashboard.ga.kpi.keyEvents'), value: sumGaField(rows, 'keyEvents') || '—' },
    {
      label: t('dashboard.ga.kpi.screenPageViews'),
      value: sumGaField(rows, 'screenPageViews') || '—',
    },
    {
      label: t('dashboard.ga.kpi.bounceRate'),
      value: latest ? formatPercent(latest.bounceRate) : '—',
    },
    {
      label: t('dashboard.ga.kpi.crashFreeRate'),
      value: latest ? formatPercent(latest.crashFreeUsersRate) : '—',
    },
    {
      label: t('dashboard.ga.kpi.avgSessionDuration'),
      value: latest?.averageSessionDuration
        ? formatEngagementDuration(latest.averageSessionDuration)
        : '—',
    },
    {
      label: t('dashboard.ga.kpi.avgEngagement'),
      value: latest?.dau ? formatEngagementDuration(avgEngagementPerUser(latest)) : '—',
    },
    {
      label: t('dashboard.ga.kpi.topEvent'),
      value: latest?.topEventCount ?? '—',
      hint: latest?.topEventName || undefined,
    },
  ];

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 xl:grid-cols-6">
        {primary.map((card) => (
          <DashboardKpi
            key={card.label}
            label={card.label}
            value={card.value}
            accent={card.accent}
            size="primary"
          />
        ))}
      </div>
      <div className="grid grid-cols-3 gap-2 xl:grid-cols-6 2xl:grid-cols-9">
        {secondary.map((card) => (
          <DashboardKpi
            key={card.label}
            label={card.label}
            value={card.value}
            hint={card.hint}
            size="compact"
          />
        ))}
      </div>
    </div>
  );
}
